export default "__VITE_ASSET__QM1a24Gk__"